(function () {
    'use strict';

    angular.module("imApp").factory("p2SettingEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 7,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 8,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
